import { useMocks } from '../../shared/env';
import type { CompaniesGateway } from './CompaniesGateway';
import { HttpCompaniesGateway } from './HttpCompaniesGateway';
import { MockCompaniesGateway } from './MockCompaniesGateway';

export const companiesGateway: CompaniesGateway = useMocks ? new MockCompaniesGateway() : new HttpCompaniesGateway();
export type { CompaniesGateway, CreateCompanyInput, UpdateCompanyInput } from './CompaniesGateway';
